import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=b34dcba0&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import "./ResetPassword.vue?vue&type=style&index=0&id=b34dcba0&prod&scoped=true&lang=scss&media=screen"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34dcba0",
  null
  
)

export default component.exports